module.exports = __webpack_public_path__ + "static/media/press-tc-article.b7f61b64.jpg";